import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Constants from '../../definitions/constants';

const PublicRoute = ({component: Component, restricted, cookies, ...rest}) => {
    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => (
            cookies.get("auth") && restricted ?
                <Redirect to={Constants.app.routes.home} />
            : <Component {...props} />
        )} />
    );
};

export default PublicRoute;


// WEBPACK FOOTER //
// ./source/router/routeTypes/publicRoute.jsx